import { useToastStore } from '@/platform/updates/common/toastStore'

export function useToast() {
  const toastStore = useToastStore()

  const showSuccess = (message: string) => {
    toastStore.add({
      severity: 'success',
      summary: '成功',
      detail: message,
      life: 3000
    })
  }

  const showError = (message: string) => {
    toastStore.add({
      severity: 'error',
      summary: '错误',
      detail: message,
      life: 5000
    })
  }

  const showInfo = (message: string) => {
    toastStore.add({
      severity: 'info',
      summary: '信息',
      detail: message,
      life: 3000
    })
  }

  const showWarning = (message: string) => {
    toastStore.add({
      severity: 'warn',
      summary: '警告',
      detail: message,
      life: 4000
    })
  }

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning
  }
}
